import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'
import { AuthProvider } from './context/auth/AuthProvider'
import { I18nProvider } from './context/i18n/I18nProvider'
import { ToastProvider } from './context/toast/toastProvider'
import ThemeProvider from './context/theme/ThemeProvider'
import { ModalProvider } from './context/modal/ModalProvider'

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <ModalProvider>
        <AuthProvider>
          <ToastProvider>
            <ThemeProvider>
              <RouterProvider router={router} />
            </ThemeProvider>
          </ToastProvider>
        </AuthProvider>
      </ModalProvider>
    </I18nProvider>
  </StrictMode>
)
